interface Props {
  size?: number;
}

export default function MetamaskIcon(props: Props) {
  const { size = 100 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7765 1.9L14.4588 8.77059L16.1529 4.72353L23.7765 1.9Z"
        fill="#E2761B"
        stroke="#E2761B"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.12941 1.9L11.4471 8.86471L9.84706 4.72353L2.12941 1.9ZM20.3882 17.9941L17.9412 21.7588L23.3059 23.2647L24.8118 18.0882L20.3882 17.9941ZM1.18824 18.0882L2.69412 23.2647L8.05882 21.7588L5.51765 17.9941L1.18824 18.0882Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.77647 11.5L6.27059 13.7588L11.5412 14.0412L11.3529 8.3L7.77647 11.5ZM18.2235 11.5L14.5529 8.20588L14.4588 14.0412L19.7294 13.7588L18.2235 11.5ZM8.05882 21.7588L11.2588 20.2529L8.43529 18.0882L8.05882 21.7588ZM14.7412 20.2529L17.9412 21.7588L17.4706 18.0882L14.7412 20.2529Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9412 21.7588L14.7412 20.2529L15.0235 22.3235L14.9294 23.1706L17.9412 21.7588ZM8.05883 21.7588L10.9765 23.1706V22.3235L11.2588 20.2529L8.05883 21.7588Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0706 16.7706L8.43529 15.9235L10.3176 15.0765L11.0706 16.7706ZM14.9294 16.7706L15.6824 15.0765L17.5647 15.9235L14.9294 16.7706Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.05882 21.7588L8.52941 17.9941L5.51765 18.0882L8.05882 21.7588ZM17.4706 17.9941L17.9412 21.7588L20.3882 18.0882L17.4706 17.9941ZM19.7294 13.7588L14.4588 14.0412L14.9294 16.7706L15.6824 15.0765L17.5647 15.9235L19.7294 13.7588ZM8.43529 15.9235L10.3176 15.0765L11.0706 16.7706L11.5412 14.0412L6.27059 13.7588L8.43529 15.9235Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.27059 13.7588L8.43529 18.0882V15.9235L6.27059 13.7588ZM17.5647 15.9235L17.4706 18.0882L19.7294 13.7588L17.5647 15.9235ZM11.5412 14.0412L11.0706 16.7706L11.6353 19.9706L11.8235 15.7353L11.5412 14.0412ZM14.4588 14.0412L14.1765 15.7353L14.2706 19.9706L14.9294 16.7706L14.4588 14.0412Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9294 16.7706L14.2706 19.9706L14.7412 20.2529L17.4706 18.0882L17.5647 15.9235L14.9294 16.7706ZM8.43529 15.9235V18.0882L11.2588 20.2529L11.6353 19.9706L11.0706 16.7706L8.43529 15.9235Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9294 23.1706L15.0235 22.3235L14.7412 22.1353H11.1647L10.9765 22.3235V23.1706L8.05883 21.7588L9.09412 22.6059L11.1647 24.1118H14.7412L16.9059 22.6059L17.9412 21.7588L14.9294 23.1706Z"
        fill="#C0AD9E"
        stroke="#C0AD9E"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1529 9.24118L25 5.38235L23.7765 1.9L14.7412 8.58235L18.2235 11.5L23.1176 13.0059L24.2471 11.6882L23.7765 11.3118L24.5294 10.6529L23.9647 10.1824L24.7176 9.61765L24.1529 9.24118ZM1 5.38235L1.75294 9.24118L1.28235 9.61765L2.03529 10.1824L1.47059 10.6529L2.22353 11.3118L1.75294 11.6882L2.78824 13.0059L7.77647 11.5L11.2588 8.58235L2.12941 1.9L1 5.38235Z"
        fill="#763D16"
        stroke="#763D16"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7412 20.2529L14.2706 19.9706H11.6353L11.2588 20.2529L10.9765 22.3235L11.1647 22.1353H14.7412L15.0235 22.3235L14.7412 20.2529Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1176 13.0059L18.2235 11.5L19.7294 13.7588L17.4706 18.0882H24.8118L23.1176 13.0059ZM7.77647 11.5L2.78824 13.0059L1.18824 18.0882H8.4353L6.27059 13.7588L7.77647 11.5ZM14.4588 14.0412L14.7412 8.58236L16.1529 4.72353H9.84706L11.2588 8.58236L11.5412 14.0412L11.6353 15.7353V19.9706H14.2706V15.7353L14.4588 14.0412Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0910232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
